import React from 'react'
import ModelBob from '../model-bob/model-bob'
import SlideInstructionModel from '../../molecules/slide-instruction-model/slide-instruction-model'
import FrequentlyQuestions from '../frequently-questions/frequently-questions'
import BannerSection from '../../molecules/bannerSection/bannerSection'
import NavMenu from '../navMenu/navMenu'
// import Footer from "../../molecules/footer/footer"
import Footer from '../../../shared/components/molecules/footer/footer'

import useMediaQuery from '../../../utils/useMediaQuery'
import BannerSpotify from '../../molecules/bannerSpotify/bannerSpotify'
import BannerShop from '../../molecules/bannerShop/bannerShop'
import CommentsProduct from '../../molecules/comments-product/comments-product'
import ZonaVirtual from '../../molecules/zonaVirtual/zonaVirtual'
import GalerySection from '../galery-section/galery-section'
import {navigate} from "gatsby";

const HomeContent = () => {
  const isMobile = useMediaQuery()
  const [modalActive, setModalActive] = React.useState()
  const [commondModal, setCommondModal] = React.useState(null)
  const [isIos, setIsIos] = React.useState(false)

  React.useEffect(() => {
    let body = document.getElementsByTagName('body')[0]
    let html = document.getElementsByTagName('html')[0]

    if (modalActive) {
      body.classList.add('overflow-body-hidden')
      html.classList.add('overflow-body-hidden')
    } else {
      body.classList.remove('overflow-body-hidden')
      html.classList.remove('overflow-body-hidden')
    }
  }, [modalActive])

  React.useEffect(() => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setIsIos(true)
    }else{
      setIsIos(false)
    }
  }, [])

  React.useEffect(() => {
    console.log(window.location.href)
    if(window.location.href.includes('#experiencia')){
      navigate('/#experiencia')
    }
  }, []);



  return (
    <>
      {modalActive}
      <NavMenu isMobile={isMobile} />
      <BannerSection isMobile={isMobile} />
      <ModelBob />
      <ZonaVirtual isMobile={isMobile} isIos={isIos} />
      <GalerySection />
      <BannerSpotify />
      <CommentsProduct isMobile={isMobile} setModalActive={setModalActive} />
      <BannerShop />
      <FrequentlyQuestions />
      <Footer setCommondModal={setCommondModal} mobile={isMobile} />
    </>
  )
}

export default HomeContent
